module.exports = __webpack_public_path__ + "img/221.8a0c72a1.jpg";